// extracted by mini-css-extract-plugin
export default {"page__loading":"page-loading_page__loading__7DgJ3"};